
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 22 20","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12 0c.552 0 1 .4 1 .892v9.216c0 .493-.448.892-1 .892s-1-.4-1-.892V.892C11 .399 11.448 0 12 0z","fill":"#000"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15.62 8.257c.443.398.508 1.114.145 1.6L11.923 15 7.304 9.941a1.215 1.215 0 010-1.608.976.976 0 011.469 0l2.996 3.281 2.389-3.197c.363-.486 1.017-.558 1.461-.16z","fill":"#000"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.31 9H2.2a.75.75 0 01.01 0H.732A.733.733 0 000 9.733V15.6A4.4 4.4 0 004.4 20h13.2a4.4 4.4 0 004.4-4.4V9.733A.733.733 0 0021.267 9H19.8h-.003.003-9.49zm0 0h-8.1c.42.005.723.37.723.733v5.135A2.932 2.932 0 005.867 17.8h10.266a2.933 2.933 0 002.934-2.932V9.733c0-.365.406-.731.73-.733H10.31z","fill":"#000"}})])
          )
        }
      }
    